import React, { useState, useEffect, useRef, useCallback } from "react";
import countriesData from "../../Data/CountryCodes.json";
import { useToast } from "../../Utils/toastContext";

const EmailVerificationModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  email,
  setEmail,
  file,
  setFile,
  userName,
  setUserName,
  selectedCode,
  setSelectedCode,
  focus,
  setFocus,
  mobileNumber,
  setMobileNumber,
  emailSent,
  handleSendLink,
  handleCodeChange,
}) => {
  const [countries, setCountries] = useState([]);
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCountries(countriesData);
  }, []);
  if (!isOpen) return null;

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFile(selectedFile);
      } else {
        alert("File must be PDF, PNG, or JPEG and less than 10MB.");
      }
    }
  };
  const handleDeleteFile = () => {
    setFile(null);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg py-4 px-6 w-[90%] max-w-3xl space-y-2 relative">
        {/* Header with Close Icon */}
        <div className="flex items-start justify-between">
          <h2 className="text-xl font-medium text-gray-800 pr-4">
            {title}
            {subtitle && <span className="text-black"> {subtitle}</span>}
          </h2>
          <button
            onClick={onClose}
            className="text-black hover:text-gray-700 font-bold text-lg leading-none"
          >
            ✕
          </button>
        </div>

        {!emailSent ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-4">
              {/* Left Section - Document Information */}
              <div>
                <label className="block text-sm font-medium mb-2">
                  Your Name <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  className="text-sm w-full rounded-xl border border-gray-300 px-3 py-2 mb-4"
                  placeholder="Your Name Here..."
                />

                <label className="block text-sm font-medium mb-2">
                  Email Address <span className="text-red-500"> *</span>
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className=" text-sm mt-1 block w-full rounded-xl border border-gray-300 px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
                {email != "" && !validateEmail(email) && (
                  <label
                    htmlFor="confirmpassword"
                    className="mt-1 flex items-center font-normal text-xs text-[#FF5050]"
                  >
                    <img
                      src="/danger.svg"
                      alt="alert Icon"
                      className="h-4 w-4 mr-2"
                    />
                    Please enter a valid email address.
                  </label>
                )}
                <div className="mt-2">
                  <label
                    htmlFor="mobileNumber"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Mobile Number
                  </label>
                  <div className="flex  items-center">
                    <select
                      value={selectedCode}
                      onChange={handleCodeChange}
                      onFocus={() => setFocus(true)}
                      onBlur={() => setFocus(false)}
                      className={`text-sm font-medium h-[2.4rem]
                            rounded-tl-xl rounded-tr-none rounded-br-none rounded-bl-xl ${
                              focus ? "border-black" : "border-gray-300"
                            } border-r-0  border-2 py-1 px-3 leading-tight focus:outline-none `}
                      placeholder="AU+61"
                    >
                      {countries.map((country) => (
                        <option
                          className="text-xs"
                          key={country.code}
                          value={country.dialCode}
                        >
                          {country.code} {country.dialCode}
                        </option>
                      ))}
                    </select>
                    <input
                      type="tel"
                      id="mobileNumber"
                      value={mobileNumber}
                      onFocus={() => setFocus(true)}
                      onBlur={() => setFocus(false)}
                      onChange={(e) => setMobileNumber(e.target.value)}
                      placeholder="Mobile Number"
                      className={`border text-black text-sm font-medium h-[2.4rem]
                         py-2 px-3  rounded-tl-none rounded-tr-xl rounded-br-xl rounded-bl-none border-2 ${
                           focus ? "border-black" : "border-gray-300"
                         } focus:outline-none w-full border-l-0 appearance-none`}
                    />
                  </div>
                </div>
              </div>

              {/* Right Section - Upload Document */}
              <div>
                <label className="block text-sm font-medium mb-2">
                  Upload Proof <span className="text-red-500"> *</span>
                </label>

                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    onChange={handleFileChange}
                    className="hidden"
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or Click to Upload
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {/* Display Uploaded File Information */}
                {file && (
                  <div className="text-sm mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <span className="text-black">{file.name}</span>
                    <button
                      onClick={handleDeleteFile}
                      className="text-red-500 flex-shrink-0 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Success Icon"
                        className="h-4 w-4 flex-shrink-0"
                      />
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-center mt-6">
              <button
                onClick={onClose}
                className="px-10 py-2 bg-white text-black mr-4 border-black border rounded-full text-sm"
              >
                Cancel
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();

                  if (!userName) {
                    showToast("Please enter your name", "error");
                    return;
                  }
                  if (!email || !validateEmail(email)) {
                    showToast("Please enter a valid email", "error");
                    return;
                  }
                  if (!file) {
                    showToast("Please upload a proof", "error");
                    return;
                  }
                  // setLoading(true);
                  handleSendLink();
                }}
                className="px-10 py-2 bg-black text-white rounded-full text-sm"
              >
                Send Access Request
              </button>
            </div>
            {/* <label className="block text-sm font-medium text-gray-700">
              Enter your email to receive a verification link:
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
            {email != "" && !validateEmail(email) && (
              <label
                htmlFor="confirmpassword"
                className="flex items-center font-normal text-xs text-[#FF5050]"
              >
                <img
                  src="/danger.svg"
                  alt="alert Icon"
                  className="h-4 w-4 mr-2"
                />
                Please enter a valid email address.
              </label>
            )}
            <button
              onClick={handleSendLink}
              className="w-full bg-[#005A9C] text-white font-semibold py-2 rounded-md hover:bg-blue-700 transition"
            >
              Send Link
            </button> */}
          </>
        ) : (
          <div className="text-green-600 font-medium text-center">
            A request has been sent to the admin for <strong>{email}</strong>.
            Once approved, you will receive a verification link in your inbox.
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationModal;
